/* eslint-disable react/button-has-type */
/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Helmet } from 'react-helmet-async';
// import * as Router from 'react-router-dom';
import ReactApexChart from 'react-apexcharts';
import Slider from 'react-slick';
import Alert from '@mui/material/Alert';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import { FaArrowRight } from 'react-icons/fa';
import toast from 'react-hot-toast';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { addDays } from 'date-fns';
import CircularProgress from '@mui/material/CircularProgress';

// type ValuePiece = Date | null;

// type Value = ValuePiece | [ValuePiece, ValuePiece];

import {
  Card,
  CardContent,
  Link,
  TextField,
  Typography,
  // Stack, 
  // IconButton, 
  // InputAdornment, 
  // TextField, 
  // Checkbox, 
  // Container, 
  // Button 
} from '@mui/material';

import { useEffect, useState } from "react";
import GlobalModal from "../../Modals/GlobalModal";
import styles from './Page.module.css'
import Filter1 from '../Filter/Filter1';


// ----------------------------------------------------------------------

export default function AdminDashboardAppPage() {
  const today = new Date();
  const notify = (msg) => toast.success(msg);
  const [date, setDate] = useState(new Date());
  const [notifyError, setNotifyError] = useState(false);
  const [isSubmitPending, setIsSubmitPending] = useState(false);
  const [savingModalOpen, setSavingModalOpen] = useState(false);
  const [reviewSavings, setReviewSavings] = useState(false);
  const [savingsType, setSavingsType] = useState('');
  const [reviewedPlan, setReviewedPlan] = useState(false);
  const [openSavingSelectedPlan, setOpenSavingSelectedPlan] = useState(false);
  const [savingSelectedPlanAmount, setSavingSelectedPlanAmount] = useState(0);
  const [savingsFormValues, setSavingsFormValues] = useState({
    duration_option: 'weekly',
    charge_type: 'automatic',
    type: savingsType,
    target_amount: 0,
    from: null,
    to: null,
  });

  const handleDateClick = (date) => {
    if (!savingsFormValues.from) {
      // If "from" date is not set, set it
      setSavingsFormValues({ ...savingsFormValues, from: date, to: null });
    } else if (!savingsFormValues.to && date > savingsFormValues.from) {
      // If "to" date is not set and selected date is after "from" date, set it
      setSavingsFormValues({ ...savingsFormValues, to: date });
    } else {
      // Reset selection if both dates are already set
      setSavingsFormValues({ from: null, to: null });
    }
  };

  const fromDateString = savingsFormValues.from ? savingsFormValues.from.toDateString() : 'Date From';
  const toDateString = savingsFormValues.to ? savingsFormValues.to.toDateString() : 'Date To';

  const tileClassName = ({ date, view }) => {
    if (
      view === 'month' &&
      savingsFormValues.from &&
      date >= savingsFormValues.from &&
      (!savingsFormValues.to || date <= savingsFormValues.to)
    ) {
      return 'selected-range';
    }
    return null;
  };

  const targetAmount = Number(savingsFormValues?.target_amount);
  // const formattedAmount = targetAmount.toLocaleString();

  // Calculate 3% of the target amount
  const threePercentOfTarget = (targetAmount * 0.02)
  // .toLocaleString(
    // undefined, 
    // {
    //   style: 'currency',
    //   currency: 'NGN',
    // }
  // );

  const handleKoloModalClose = () => {
    setSavingModalOpen(false);
  };

  const handleSavingSelectedClose = () => {
    setOpenSavingSelectedPlan(false);
    setSavingsFormValues({
      duration_option: 'weekly',
      charge_type: 'automatic',
    })
    setSavingsType('')
    setNotifyError(false)
  };

  const handleReviewSavingsClose = () => {
    setReviewSavings(false);
    setReviewedPlan(false);
    setOpenSavingSelectedPlan(!openSavingSelectedPlan);
  };

  const [chartOptions] = useState({
    chart: {
      type: 'bar'
    },
    colors: ['rgba(0, 175, 82, 1)', 'rgba(0, 175, 82, .7)', 'rgba(0, 175, 82, 1.4)'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        borderRadius: 5,
        borderRadiusApplication: 'end'
      },
    },
    xaxis: {
      categories: ['Nigeria', 'Ghana', 'South Africa', 'Egypt', 'Benin', 'Liberia', 'Togo', 'Sierrelone', 'Senegal'],
    },

    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter(val) {
          return `$ ${val}`
        }
      }
    },
    dataLabels: {
      enabled: false,
    }
  })
  const [chartSeries] = useState(
    [{
      name: 'Order',
      data: [900, 550, 800, 810, 810, 600, 400, 400]
    },
    {
      name: 'Depletion',
      data: [800, 700, 600, 500, 800, 700, 650, 600]
    },
    {
      name: 'In-stock',
      data: [650, 700, 750, 890, 800, 400, 350, 480]
    }]
  );

  const [savingPlansAmount, setSavingPlansAmount] = useState(
    [
      'Custom Plan',
      '100',
      '200',
      '300',
      '500',
      '1,000',
      '2,000',
      '5,000',
      '10,000',
    ]
  );

  // for carousel
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000,
    fade: true,
    scrollBar: false
  };

  const onCustomClick = (val) => {
    handleKoloModalClose();
    setSavingSelectedPlanAmount(val);
    setOpenSavingSelectedPlan(!openSavingSelectedPlan); 
    if(val !== 'Custom Plan') {
      setSavingsFormValues((prev) => {
        return {
          ...prev,
          amount: val,
        }
      })
    }
  }

  const handleBeginWithSavings = (val) => {
    setSavingsType(val)
    if(val !== 'Fixed Savings') {
      setSavingModalOpen(true)
    } else {
      setOpenSavingSelectedPlan(true)
    }
  }

  const handleSavingsFormValues = (key, value) => {
    console.log(key, value);
    setSavingsFormValues((prev) => {
      return {
        ...prev,
        [key]: value,
      }
    })
  }

  const handleProceedCustomPlan = (val) => {
    if(val <= 0 ) {
      notify('Amount should be greater than or ₦100')
      return;
    }

    setSavingSelectedPlanAmount(val)
  }

  const handleProceedSavings = (val, val2, val3) => {
    if((val === '' || val3 <= 0 ) || (val2 === '' || val2 === null) || (fromDateString === 'Date From' || toDateString === 'Date To')) {
      setNotifyError(true)
      return;
    }
    console.log(savingsFormValues)
    setOpenSavingSelectedPlan(false);
    setReviewSavings(!reviewSavings);
    setNotifyError(false)
  }

  const handleSetReviewedPlan = () => {
    setReviewedPlan(!reviewedPlan)
  }

  const handleSubmitSavingPlan = () => {
    setIsSubmitPending(true)

    setTimeout(() => {
      setReviewSavings(!reviewSavings);
      setIsSubmitPending(false)
      setSavingsFormValues({
        duration_option: 'weekly',
        charge_type: 'automatic',
      })
      setSavingsType('')
    }, [2000])
  }

  return (
    <>
      {/* <Helmet>
        <title> Dashboard </title>
      </Helmet> */}
      <div className='wrapper mt-md-3 mt-4'>
        {/* <div className={`${styles.header} d-block d-md-none mb-4 mt-3 pt-2`}>
          <h4 className={`mb-0 pb-0`}>Dashboard</h4>
          <p style={{ fontSize: '14px' }} className={`mb-0 pb-0`}>
            An overview of your business performance
          </p>

        </div> */}

        <i className='font-weight-bold'>
          Welcome Back Assiduous
        </i>

        {/* Banner */}
        <div style={{ overflow: 'hidden', marginTop: '20px' }}>
          <Slider {...settings}>
            <div>
              <Typography variant="h3" className={`${styles.banner} border`}>
                <div>
                  <h3 className='text-white font-weight-bold'>
                    <i>iSAVE</i>
                  </h3>
                  <i className='text-white font-weight-small pl-mdk-4 mb-0' style={{fontSize: '14px'}}>
                    Financial Innovation we have brought to make your Goals become Achievable.
                  </i>
                </div>
                <div className={`${styles.banner_img}`}>
                  <img src='/assets/hero-money' alt='' />
                </div>
                {/* <img src="/assets/icons/bannerImageOne.png" className={`${styles.banner_img1}`} alt="" /> */}
              </Typography>
            </div>
            <div>
              <Typography variant="h3" className={`${styles.banner_sec} border bg-primary`}>
                <div className={`${styles.kolo_section}`}>
                  <div>
                    <h2 className={`${styles.kolo_title_section}`} >
                      <i>Kolo Challenge📦</i>
                    </h2>
                    <i className='font-weight-small pl-md-l4 mb-0' style={{fontSize: '14px'}}>
                      Owo December in my kolo. A challenge for your savings growth. Get started with kolo for a detty december.
                    </i>
                  </div>
                </div>
                {/* <div className={`${styles.banner_img}`}>
                  <img src='/assets/hero-money' alt='' />
                </div> */}
                  {/* <img src='/assets/rabbit_white.png' className='img-fluid img-responsive' alt='' /> */}
              </Typography>
            </div>
            <div>
              <Typography variant="h3" className={`${styles.banner} border`}>
                <div>
                  <h3 className='text-white font-weight-bold'>
                    <i>Ajo</i>
                  </h3>
                  <i className='text-white font-weight-small pl-mdk-4 mb-0' style={{fontSize: '14px'}}>
                    Kowope Alajo is digital 🤩 Contribution scheme for better productivity.
                  </i>
                </div>
                <div className={`${styles.banner_img}`}>
                  <img src='/assets/images/thrift-balance.png' alt='' />
                </div>
              </Typography>
            </div>
          </Slider>
        </div>

        <div clasjsName={styles.landing} />
        <div className="row mt-4">
          <div className="col-md-12 mb-2">
            <div className="row">
              <div className="col-md-6 mb-4">
                <div className={`${styles.card}`}>
                  <div className={`card-body`}>
                    <div 
                      className="d-flex justify-content-between" 
                      style={{borderBottom: '1px solid #2A0236'}}
                    >
                      <small>Total Savings</small>
                    </div>
                    <div className={`${styles.numbers}`}>
                      <div>
                        <h4 className='primary_color'>100,000</h4>
                      </div>
                      <div>
                          <button 
                            type='button' 
                            className='btn text-white' 
                            style={{
                              backgroundColor: '#2A0236', 
                              borderRadius: '2px',
                            }}
                          >
                            <small className='text-white'>see more..</small>
                          </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <div className={`${styles.card}`}>
                  <div className={`card-body`}>
                    <div className="d-flex justify-content-between" style={{borderBottom: '1px solid #2A0236'}}>
                      <small>Interest</small>
                    </div>
                    <div className={`${styles.numbers}`}>
                      <div>
                        <h4 className='primary_color'>20,000</h4>
                      </div>
                      <div>
                          <button 
                            type='button' 
                            className='btn text-white' 
                            style={{
                              backgroundColor: '#2A0236', 
                              borderRadius: '2px',
                            }}
                          >
                            <small className='text-white'>see more..</small>
                          </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-6 mb-4">
                <div className={`${styles.card}`}>
                  <div className={`card-body`}>
                    <div className="d-flex justify-content-between">
                      <small>Deliveries</small>
                    </div>
                    <div className={`${styles.numbers}`}>
                      <div>
                        <span className='primary_color'>1,206</span><small> from 1,021</small>
                      </div>
                      <div>
                        <div style={{
                          width: '67px',
                          height: '25px',
                          borderRadius: '12px',
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: ' space-around'
                        }} className={styles.percent}>
                          <img src="/assets/icons/up.svg" alt="" /> <small>12%</small>

                        </div>
                      </div>



                    </div>

                  </div>


                </div>
              </div>
              <div className="col-md-6 mb-4">
                <div className={`${styles.card}`}>
                  <div className={`card-body`}>
                    <div className="d-flex justify-content-between">
                      <small>Routes</small>
                    </div>
                    <div className={`${styles.numbers}`}>
                      <div>
                        <span className='primary_color'>1,206</span><small> from 1,021</small>
                      </div>
                      <div>
                        <div style={{
                          width: '67px',
                          height: '25px',
                          borderRadius: '12px',
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: ' space-around'
                        }} className={styles.percent}>
                          <img src="/assets/icons/up.svg" alt="" /> <small>12%</small>

                        </div>
                      </div>



                    </div>

                  </div>


                </div>
              </div> */}
            </div>
          </div>
        </div>
        <h5 className={styles.recommendations}>
          Recommendations
        </h5>
        <div className="row mt-4">
          <div className="col-md-12 mb-2">
            <div className="row">
              <div className="col-md-4 mb-4" style={{cursor: 'pointer'}}>
                <div className={`${styles.card}`}>
                  <div 
                    className={`card-body row`} 
                    style={{
                      backgroundColor: '#2A0236', 
                      height: '120px', 
                      position: 'relative',
                      padding: '0px 2px 0px 0px'
                    }}
                  >
                    <div className="col-md-6 p-3 text-white">
                      <h2>Kolo</h2>
                      <h4>
                        <i>Challenge</i>
                      </h4>
                    </div>
                    <div 
                      className={`${styles.recommendation_card_kolo} col-md-6`} 
                    >
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className={`${styles.card}`}>
                  <div 
                    className={`card-body row`} 
                    style={{
                      backgroundColor: '#2A0236', 
                      height: '120px', 
                      position: 'relative',
                      padding: '0px 0px 0px 2px'
                    }}
                  >
                    <div className={`${styles.recommendation_card_land} col-md-6`}>
                    </div>
                    <div className="col-md-6 p-3" style={{color: '#E82EFF'}}>
                      <h2>Get a</h2>
                      <h4>
                        <i>Land</i>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className={`${styles.card}`}>
                  <div 
                    className={`card-body row`} 
                    style={{
                      backgroundColor: '#2A0236', 
                      height: '120px', 
                      position: 'relative',
                      padding: '0px 2px 0px 0px'
                    }}
                  >
                    <div className="col-md-6 p-3 text-white">
                      <h2>Ajo</h2>
                      <h4>
                        <i>Savings</i>
                      </h4>
                    </div>
                    <div 
                      className={`${styles.recommendation_card_ajo} col-md-6`}
                    >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Card style={{ marginTop: '50px', marginBottom: '20px', borderRadius: '10px' }} className='p-0'>
          <CardContent>
            <div className={`${styles.insight_header} pl-md-5`}>
              <h5>
                Quick Start
              </h5>
              <div style={{padding: '10px', borderBottom: '1px solid #2A0236'}}>
                <div className="d-md-flex justify-content-between">
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <div className="initials">
                      {/* AM */}
                      <img src="/assets/illustrations/illustration_avatar.png" alt="" style={{ width: '50px' }} />
                    </div>
                    &nbsp;
                    <div className=" ">
                      <p className="mb-0" style={{ fontSize: '14px' }}>
                        <strong>
                          Target Savings
                        </strong>
                      </p>
                      <span style={{ fontSize: '14px' }}>
                        Target savings goal guides your financial decisions and help you create a structured savings plan. 
                      </span>
                    </div>
                  </div>
                  <button 
                    type='button' 
                    className='btn text-white' 
                    style={{
                      background: 'rgb(30, 2, 54)',
                      width: '18%',
                    }}
                    onClick={() => handleBeginWithSavings('Target Savings')}
                  >
                    <AddToPhotosIcon fontSize="small" style={{ marginRight: '5px' }} /> Get Started
                  </button>
                </div>
              </div>
              <div style={{padding: '10px', borderBottom: '1px solid #2A0236'}}>
                <div className="d-md-flex justify-content-between">
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <div className="initials">
                      <img src="/assets/illustrations/illustration_avatar.png" alt="" style={{ width: '50px' }} />
                    </div>
                    &nbsp;
                    <div className=" ">
                      <p className="mb-0" style={{ fontSize: '14px' }}>
                        <strong>
                          Fixed Savings
                        </strong>
                      </p>
                      <span style={{ fontSize: '14px' }}>
                        Set up a long term savings or short terms saving to meeting specific financial goals.
                      </span>
                    </div>
                  </div>
                  <button 
                    type='button' 
                    className='btn text-white' 
                    style={{
                      background: 'rgb(30, 2, 54)',
                      width: '18%',
                    }}
                    onClick={() => handleBeginWithSavings('Fixed Savings')}
                  >
                    <AddToPhotosIcon fontSize="small" style={{ marginRight: '5px' }} /> Get Started
                  </button>
                </div>
              </div>
              <div style={{padding: '10px', borderBottom: '1px solid #2A0236'}}>
                <div className="d-md-flex justify-content-between">
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <div className="initials">
                      <img src="/assets/illustrations/illustration_avatar.png" alt="" style={{ width: '50px' }} />
                    </div>
                    &nbsp;
                    <div className=" ">
                      <p className="mb-0" style={{ fontSize: '14px' }}>
                        <strong>
                          Flex Me
                        </strong>
                      </p>
                      <span style={{ fontSize: '14px' }}>
                        Save to withdraw anytime of your choice. Go Enjoy!
                      </span>
                    </div>
                  </div>
                  <button 
                    type='button' 
                    className='btn text-white' 
                    style={{
                      background: 'rgb(30, 2, 54)',
                      width: '18%',
                    }}
                    onClick={() => handleBeginWithSavings('Flex Me')}
                  >
                    <AddToPhotosIcon fontSize="small" style={{ marginRight: '5px' }} /> Get Started
                  </button>
                </div>
              </div>
              {/* <div className="d-md-flex justify-content-between">
                <p>
                  Compare your orders against the depletion rate and <br /> what is left in Stock in your Stores.
                </p>
                <div className="d-flex">
                  <div className="dropleft ">
                    <button type='button' className="btn  border" onClick={() => setSavingModalOpen(true)}
                      style={{
                        backgroundColor: '#fff',
                        border: '1px solid #D0D5DD',
                        boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                        borderRadius: '4px'
                      }}>
                      <img className="" style={{ display: 'inline', width: '28%' }} src="/assets/icons/filterlines.svg" alt="" />
                      &nbsp;
                      <small className="d-none d-md-inline-block">
                        Filters
                      </small>
                    </button>

                  </div>
                  &nbsp;
                  &nbsp;
                  <div className="dropleft ">
                    <button type='button' id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" className={`${styles.export_btn} btn m-0 py-0`}>
                      <span style={{
                        paddingTop: '8px',


                      }}>
                        <img style={{ display: 'inline', width: '18%' }} src="/assets/icons/download.svg" alt="" /> &nbsp;
                        Export
                      </span>
                      &nbsp;
                      &nbsp;
                      <span style={{
                        borderLeft: '1px solid white',
                        display: 'inline-block',
                        height: 'inherit',
                        paddingTop: '8px',
                        paddingLeft: '8px',
                        textAlign: 'center',

                      }}>
                        <img src="/assets/icons/arrowDown.svg" alt="" />

                      </span>


                    </button>

                    <div className="dropdown-menu drop-left" aria-labelledby="dropdownMenuButton">
                      <button type="button" className="rss dropdown-item btn border-0">CSV</button>
                      <button type="button" className="rss dropdown-item btn border-0">Excel </button>
                    </div>
                  </div>
                </div>

              </div>
              <div className="row mt-md-0 mt-4">
                <div className="col-md-8 mb-2"
                >
                  <div className="row">
                    <div className="col-md-12 mb-2">
                      <div className="d-lg-flex d-block" style={{ gap: '20px' }}>
                        <div className="d-block">
                          <div className="card p-0" style={{ minWidth: '20em', height: '35px' }}  >
                            <div className="card-body d-flex justify-content-around  py-1" style={{ whiteSpace: 'nowrap' }}>
                              <div className='d-inline m-0'>
                                <input className="" type="radio" name="insight_depletion" id="ov1" />
                                <label htmlFor="ov1">
                                  Overall
                                </label>
                              </div>
                              <div className='d-inline m-0'>
                                <input className="" type="radio" name="insight_depletion" id="year1" />
                                <label htmlFor="year1">
                                  Yearly
                                </label>
                              </div>
                              <div className='d-inline m-0'>
                                <input className="" type="radio" name="insight_depletion" id="month1" />
                                <label htmlFor="month1">
                                  Monthly
                                </label>
                              </div>
                            </div>

                          </div>

                        </div>
                        <div className="d-block">
                          <div className="m-0">
                            <div className="mt-2">
                              <div className="p-0 mx-auto mt-3 mt-lg-0" style={{ width: 'fit-content' }}>
                                <span>
                                  <span className={`${styles.arrowSpan}`}>
                                    <img width={'20px'} src="/assets/icons/left_arrow.svg" alt="arrow" className={`${styles.newStyle} mr-2`} />
                                  </span>
                                  <span className={`${styles.year_styles}`}>2023</span>
                                  <span className={`${styles.arrowSpan}`}>
                                    <img width={'20px'} src="/assets/icons/right_arrow.svg" alt="arrow" className={`${styles.newStyle} ml-2`} />
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="col-md-3  text-md-right" style={{ whiteSpace: 'nowrap' }}>
                  <span>
                    <img src="/assets/icons/ordercolor.svg" alt="" />
                    &nbsp;
                    Users
                  </span>
                  &nbsp;
                  <span>
                    <img src="/assets/icons/depletionColor.svg" alt="" />
                    &nbsp;
                    Bookings
                  </span>
                  &nbsp;
                  <span>
                    <img src="/assets/icons/instockColor.svg" alt="" />
                    &nbsp;
                    Income
                  </span>


                </div>
              </div> */}
            </div>

            {/* <ReactApexChart type="bar" series={chartSeries} options={chartOptions} height={500} /> */}

          </CardContent>

        </Card>

        {/* Fiter Modal */}
        <GlobalModal
          open={savingModalOpen}
          onClose={handleKoloModalClose}
          position='absolute'
          top='50%'
          left='50%'
          transform='translate(-50%, -50%)'
          width='740px !important'
          overflowY='scroll'
          bgcolor='#FFFFFF'
          // border='1px solid #F5F5F5'
          borderRadius='5px'
          boxShadow='24'
          p='25px'
        >
          <div className={`${styles.modal_content}`}>
            <div className={`${styles.modal_header} mb-0`}>
              <h5 style={{
                fontSize: '19px',
                fontWeight: '700',

              }}>{savingsType}</h5>
              <span onClick={handleKoloModalClose} style={{ cursor: 'pointer' }}>
                <img src="/assets/icons/x.svg" alt="" />
              </span>
            </div>
            <small>
                {
                  savingsType === 'Target Savings' && (
                    <span>
                      Set up a financial goal to accumulate a predetermined amount of money within a defined timeframe. 
                      This goal could be for various purposes, such as buying a house, a car, starting a business, 
                      going on a vacation, or creating an emergency fund.
                    </span>
                  )
                } 
                {
                  savingsType === 'Fixed Savings' && (
                    <span>
                      Set aside a consistent or regular amount of money at predetermined intervals, such as weekly, monthly, or annually. 
                      Be part of this disciplined savings strategy to instill a habit of saving by making it a regular and non-negotiable 
                      part of your financial routine.
                    </span>
                  )
                } 
                {
                  savingsType === 'Flex Me' && (
                    <span>
                      An account prepared for you save in and withdraw at any particular time. Be flexible!🥳
                    </span>
                  )
                } 
                <b>{" "}Begin with a {savingsType} now!</b>
              </small>
            <form action="" className="mt-3">
              <div 
                className='text-white' 
                style={{
                  border: '1px solid #2A0236', 
                  borderRadius: '10px', 
                  padding: '15px', 
                  backgroundColor: '#2A0236', 
                  opacity: '0.9'
                }}
              >
                {savingPlansAmount?.length > 0 && savingPlansAmount.map((el,i) => {
                  return (
                    <div className={`${styles.kolo_plans} p-3`} onClick={() => onCustomClick(el)} key={i}>
                      {el !== "Custom Plan" ? `₦${el}` : el }
                      <div>
                        <FaArrowRight />
                      </div>
                    </div>
                  )
                })}
              </div>
            </form>
          </div>
        </GlobalModal>

         {/* Fiter Modal */}
         <GlobalModal
          open={openSavingSelectedPlan}
          onClose={handleSavingSelectedClose}
          position='absolute'
          top='50%'
          left='50%'
          transform='translate(-50%, -50%)'
          width='740px !important'
          overflowY='scroll'
          bgcolor='#FFFFFF'
          // border='1px solid #F5F5F5'
          borderRadius='5px'
          boxShadow='24'
          p='25px'
        >
          {
            savingSelectedPlanAmount === 'Custom Plan' && (
              <>
                <div className={`${styles.modal_content}`}>
                  <div className={`${styles.modal_header} mb-0`}>
                    <h5 style={{
                      fontSize: '19px',
                      fontWeight: '700',

                    }}>Custom Plan</h5>
                    <span onClick={handleSavingSelectedClose} style={{ cursor: 'pointer' }}>
                      <img src="/assets/icons/x.svg" alt="" />
                    </span>
                  </div>
                  <small>
                      We know your preferred amount may not be part of the previous listed.
                      Enter an amount to start with here to continue your saving process.
                    </small>
                  <form action="" className="mt-3">
                    <div 
                      className='text-white' 
                      style={{
                        border: '1px solid #2A0236', 
                        borderRadius: '10px', 
                        padding: '15px', 
                        backgroundColor: '#2A0236', 
                        opacity: '0.9'
                      }}
                    >
                      <div>
                        <label htmlFor="custom_amount">Enter an Amount</label>
                        <TextField 
                          name="custom_amount"
                          required
                          type='number'
                          id="custom_amount"
                          placeholder="₦200,000"
                          size="small"
                          style={{ width: '100%' }}
                          className='mt-2'
                          value={savingsFormValues?.amount}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue === '' || parseFloat(inputValue) > 0) {
                              handleSavingsFormValues('amount', inputValue);
                            }
                          }}
                          inputProps={{
                            inputMode: 'decimal',
                        }}
                        onKeyDown={(e) => {
                            if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                e.preventDefault();
                            }
                        }}
                        />
                      </div>
                    </div>
                  </form>
                </div>
                <div className="mb-4 mt-4">
                  <button 
                    type="button" 
                    className={`${styles.modal_btn} btn btn-block`}
                    onClick={() => handleProceedCustomPlan(savingsFormValues?.amount)}
                  >
                    Proceed
                  </button>
                </div>
              </>
            )
          }
          {
            savingSelectedPlanAmount !== 'Custom Plan' && (
              <>
                <div className={`${styles.modal_content}`}>
                  <div className={`${styles.modal_header} mb-0`}>
                    <h5 style={{
                      fontSize: '19px',
                      fontWeight: '700',

                    }}>Congratulations! You are Stepping Forward.</h5>
                    <span onClick={handleSavingSelectedClose} style={{ cursor: 'pointer' }}>
                      <img src="/assets/icons/x.svg" alt="" />
                    </span>
                  </div>
                  {
                    savingsType !== 'Fixed Savings' && (
                    <small>
                        You have taken a step forward to begin with a <b>{savingsType}</b> plan of a specific sum 
                        <b>{" "}₦{Number(savingsFormValues?.amount).toLocaleString()}</b>.
                          Let us know the duration or deadline by which you aim to achieve this savings goal.
                      </small>
                    )
                  }
                  {
                    savingsType === 'Fixed Savings' && (
                    <small>
                        You have taken a step forward to begin with a <b>{savingsType}</b>.
                        Let us know the duration or deadline by which you aim to achieve this savings goal.
                      </small>
                    )
                  }
                  {
                    notifyError && (
                      <Alert style={{
                          border: '1px solid red'
                        }} severity="error"
                        className='mt-3'
                      >
                          All fields are required
                      </Alert>
                    )
                  }
                  <form action="" className="mt-3">
                    <div 
                      className='text-white' 
                      style={{
                        border: '1px solid #2A0236', 
                        borderRadius: '10px', 
                        padding: '15px', 
                        backgroundColor: '#2A0236', 
                        opacity: '0.9'
                      }}
                    >
                      <div className="text-dark">
                        <label htmlFor="title"
                          className="text-white"
                        >
                          Goal Title*
                        </label>
                        <div>
                          <TextField
                              name="title"
                              required
                              type="text"
                              id="title"
                              size="small"
                              className="mt-2 mb-3 w-100"
                              value={savingsFormValues?.title}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                handleSavingsFormValues('title', inputValue);
                              }}
                            />
                        </div>
                        <span className="text-white">How you want to save ?</span>
                        <div className="card mt-3 mb-3 p-0" style={{ minWidth: '100%', height: '35px' }}  >
                            <div className="card-body d-flex justify-content-around  py-1" style={{ whiteSpace: 'nowrap' }}>
                                <div className='d-inline m-0'>
                                    <input 
                                      className="" 
                                      type="radio" 
                                      name="daily" 
                                      id="daily" 
                                      checked={savingsFormValues?.duration_option === 'daily'}
                                      onChange={() => handleSavingsFormValues('duration_option', 'daily')}
                                    />
                                    <label htmlFor="daily">
                                        Daily
                                    </label>
                                </div>
                                <div className='d-inline m-0'>
                                    <input 
                                      className="" 
                                      type="radio" 
                                      name="weekly" 
                                      id="weekly"
                                      checked={savingsFormValues?.duration_option === 'weekly'}
                                      onChange={() => handleSavingsFormValues('duration_option', 'weekly')} 
                                    />
                                    <label htmlFor="weekly">
                                        Weekly
                                    </label>
                                </div>
                                <div className='d-inline m-0'>
                                    <input 
                                      className="" 
                                      type="radio" 
                                      name="monthly" 
                                      id="monthly" 
                                      checked={savingsFormValues?.duration_option === 'monthly'}
                                      onChange={() => handleSavingsFormValues('duration_option', 'monthly')} 
                                    />
                                    <label htmlFor="monthly">
                                        Monthly
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div>
                          <label htmlFor="target_amount" className="text-white"
                          >
                            Target Amount
                          </label>
                          <TextField 
                            name="target_amount"
                            required
                            type='number'
                            id="target_amount"
                            placeholder="₦500,000"
                            size="small"
                            style={{ width: '100%' }}
                            className='mt-2 mb-3 '
                            value={savingsFormValues?.target_amount}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              if (inputValue === '' || parseFloat(inputValue) > 0) {
                                handleSavingsFormValues('target_amount', inputValue);
                              }
                            }}
                            inputProps={{
                              inputMode: 'decimal',
                          }}
                          onKeyDown={(e) => {
                              if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                  e.preventDefault();
                              }
                          }}
                          />
                        </div>
                      </div>
                      <div>
                        <span className="text-white">Duration / Maturity Date ?</span>
                        <div className='mt-3 mb-3'>
                          <TextField
                            name="dateRange"
                            required
                            type="text"
                            id="dateRange"
                            size="small"
                            style={{ width: '50%', backgroundColor: '#E82EFF' }}
                            className="mt-2 mb-3 d-flex ml-auto"
                            value={`${fromDateString} - ${toDateString}`}
                            readOnly 
                          />
                          <style>
                            {`
                              .selected-range {
                                background-color: #2A0236;
                                color: #E82EFF;
                              }
                            `}
                          </style>
                          <div>
                            <Calendar 
                              onClickDay={handleDateClick}
                              value={date} 
                              minDate={addDays(today, -1)}
                              className="w-100"
                              tileClassName={tileClassName}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="mb-4 mt-4">
                  <button 
                    type="button" 
                    className={`${styles.modal_btn} btn btn-block`}
                    onClick={() => 
                      handleProceedSavings(
                        savingsFormValues?.title, 
                        savingsFormValues?.duration_option, 
                        savingsFormValues?.target_amount,
                      )
                    }
                  >
                    Proceed
                  </button>
                </div>
              </>
            )
          }
        </GlobalModal>

        {/* Review Modal */}
        <GlobalModal
          open={reviewSavings}
          onClose={handleReviewSavingsClose}
          position='absolute'
          top='50%'
          left='50%'
          transform='translate(-50%, -50%)'
          width='740px !important'
          overflowY='scroll'
          bgcolor='#FFFFFF'
          borderRadius='5px'
          boxShadow='24'
          p='25px'
        >
          { !reviewedPlan &&
            <>
              <div className={`${styles.modal_content}`}>
                <div className={`${styles.modal_header} mb-0`}>
                  <h5 style={{
                    fontSize: '19px',
                    fontWeight: '700',

                  }}>Finally we are here! Review your savings plan</h5>
                  <span onClick={handleReviewSavingsClose} style={{ cursor: 'pointer' }}>
                    <img src="/assets/icons/x.svg" alt="" />
                  </span>
                </div>
                <small>
                  Be aware that there is an applied charges of 2% of the target amount.
                  Thank you🤝.
                </small>
              <div className='row mt-4'>
                <div className='col-6 pt-2' style={{borderRight: '1px solid #2A0236'}}>
                  <p>
                  <b>Savings Title</b>
                  </p>
                  <p>
                  <b>Savings Type</b>
                  </p>
                  <p>
                  <b>Duration</b>
                  </p>
                  <p>
                  <b>How To Save</b>
                  </p>
                  <p>
                  <b>Amount To Save</b>
                  </p>
                  <p>
                  <b>Target Amount</b>
                  </p>
                </div>
                <div className={`${styles.review_section} col-6 pt-2`}>
                  <p style={{borderBottom: '1px solid #fff'}}>
                    <i>
                      <b>
                        {savingsFormValues?.title}
                      </b>
                    </i>
                  </p>
                  <p style={{borderBottom: '1px solid #fff'}}>
                    <i>
                      <b>
                        {savingsType}
                      </b>
                    </i>
                  </p>
                  <p style={{borderBottom: '1px solid #fff'}}>
                    <i>
                      {
                        fromDateString !== 'Date From' && toDateString !== 'Date To' &&
                        <b>
                          {fromDateString } to {toDateString}
                        </b>
                      }
                    </i>
                  </p>
                  <p style={{borderBottom: '1px solid #fff'}}>
                    <i>
                      {
                        fromDateString !== 'Date From' && toDateString !== 'Date To' &&
                        <b>
                          {
                            savingsFormValues?.duration_option &&
                            savingsFormValues.duration_option.charAt(0).toUpperCase() +
                            savingsFormValues.duration_option.slice(1)
                          }
                        </b>
                      }
                    </i>
                  </p>
                  <p style={{borderBottom: '1px solid #fff'}}>
                    <i>
                      <b>
                        ₦{Number(savingsFormValues?.amount).toLocaleString()}
                      </b>
                    </i>
                  </p>
                  <p style={{borderBottom: '1px solid #fff'}}>
                    <i>
                      <b>
                        ₦{Number(savingsFormValues?.target_amount).toLocaleString() + ' +' } <small>{Number(threePercentOfTarget).toLocaleString()}</small>
                      </b>
                    </i>
                  </p>
                  <p style={{borderBottom: '1px solid #fff'}}>
                    <i>
                      <small>
                        Total: {" "}
                      </small>
                      <small>
                        <b>
                          ₦{Number(Number(savingsFormValues?.target_amount) + Number(threePercentOfTarget)).toLocaleString()}
                        </b>
                      </small>
                    </i>
                  </p>
                </div>
              </div>
              </div>
              <div className="mb-4 mt-4">
                <button 
                  type="button" 
                  disabled={isSubmitPending}
                  className={`${styles.modal_btn} btn btn-block`}
                  onClick={() => handleSetReviewedPlan()}
                >
                  Let's Go
                </button>
              </div>
            </>
          }
          {
            reviewedPlan &&
            <>
              <div className={`${styles.modal_content}`}>
                <div className={`${styles.modal_header} mb-0`}>
                  <h5 style={{
                    fontSize: '19px',
                    fontWeight: '700',

                  }}>Payment Method</h5>
                  <span onClick={handleReviewSavingsClose} style={{ cursor: 'pointer' }}>
                    <img src="/assets/icons/x.svg" alt="" />
                  </span>
                </div>
                <small>
                  Automating savings through direct debits or automated transfers can 
                  be an effective way to ensure this amount is consistently saved without 
                  requiring manual intervention each time. Choose a method you would like to pay with!
                </small>
                <div className="text-dark mt-3">
                  <span>How do you want to pay in ?</span>
                  <div className="card mt-3 mb-3 p-0" style={{ minWidth: '100%', heikght: '35px' }}  >
                      <div className="card-body d-flex justify-content-around  py-1" style={{ whiteSpace: 'nowrap' }}>
                          <div className='d-inline m-0'>
                              <input 
                                className="" 
                                type="radio" 
                                name="automatic" 
                                id="automatic" 
                                checked={savingsFormValues?.charge_type === 'automatic'}
                                onChange={() => handleSavingsFormValues('charge_type', 'automatic')}
                              />
                              <label htmlFor="automatic">
                                  Automatic
                              </label>
                          </div>
                          <div className='d-inline m-0'>
                              <input 
                                className="" 
                                type="radio" 
                                name="manual" 
                                id="manual"
                                checked={savingsFormValues?.charge_type === 'manual'}
                                onChange={() => handleSavingsFormValues('charge_type', 'manual')} 
                              />
                              <label htmlFor="manual">
                                  Manual
                              </label>
                          </div>
                          <div className='d-inline m-0'>
                              <input 
                                className="" 
                                type="radio" 
                                name="wallet" 
                                id="wallet" 
                                checked={savingsFormValues?.charge_type === 'wallet'}
                                onChange={() => handleSavingsFormValues('charge_type', 'wallet')} 
                              />
                              <label htmlFor="wallet">
                                  My iSave Wallet
                              </label>
                          </div>
                      </div>
                      {
                        savingsFormValues?.charge_type === 'automatic' &&
                        <div className='m-2'>
                          <p>
                            Saving would be deducted from the default registered card automatically at the supposed date.
                            Make sure there is fund of <b>{" "}₦{Number(savingsFormValues?.amount).toLocaleString()} {" "}</b>
                            in the selected bank account for your first savings debit.
                          </p>
                          <p>
                            <i>
                              <b>
                                Select a payment card
                              </b>
                            </i>
                          </p>
                          <div className='row'>
                            <div className="col-md-4 mb-2">
                              <div className={`${styles.card2} card ply-4 `} style={{ borderRadius: '6px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                                  <div className={`${styles.wallet}`} >
                                      {/* <img className={`${styles.img} ${styles.img1}`} src="/assets/crc.png" alt="" /> */}
                                      <div className={`${styles.content}`} >
                                          <div className={`${styles.content_header} mt-1`}>
                                              <div>
                                                  ₦‎ 26,500,853
                                              </div>
                                              <div>
                                                  <img src="/assets/icons/Vector.svg" alt="" />
                                              </div>
                                          </div>
                                          <p className={`${styles.sub_text}`}>
                                              Your Balance
                                          </p>
                                          <div className={`${styles.content_body} ${styles.content_body2}`}>
                                              <p className={`${styles.sub_text} m-0 mb-1`}>
                                                  Account Details
                                              </p>
                                              <div className={`${styles.bank_info}`}>
                                                  <div >
                                                      <p className={`${styles.name} m-0`}>
                                                          ADEOLA IDAYAT ADEOYE.

                                                      </p>
                                                      <p className={`${styles.account_number} m-0`}>
                                                          0036262435
                                                      </p>

                                                  </div>
                                                  <img className="" src="/assets/logo.svg" alt="" />
                                              </div>
                                          </div>
                                      </div>
                                      {/* <div className={`${styles.footer} ${styles.footer2}`}>
                                              <div className="">
                                                  <p className="mb-0 pb-0">
                                                      <Link
                                                          // href="/app/wallets"
                                                          href="/admin"
                                                      >
                                                          Manage Wallet
                                                          <iconify-icon icon="ph:arrow-right" style={{ fontSize: '1.5em', lineHeight: '0', marginLeft: '5px', verticalAlign: 'middle' }}></iconify-icon>
                                                          &nbsp;

                                                      </Link>


                                                  </p>

                                              </div>

                                          </div> */}

                                  </div>

                              </div>
                            </div>
                            <div className="col-md-4 mb-2">
                              <div className={`${styles.card2} card ply-4 `} style={{ borderRadius: '6px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                                  <div className={`${styles.wallet}`} >
                                      {/* <img className={`${styles.img} ${styles.img1}`} src="/assets/crc.png" alt="" /> */}
                                      <div className={`${styles.content}`} >
                                          <div className={`${styles.content_header} mt-1`}>
                                              <div>
                                                  ₦‎ 26,500,853
                                              </div>
                                              <div>
                                                  <img src="/assets/icons/Vector.svg" alt="" />
                                              </div>
                                          </div>
                                          <p className={`${styles.sub_text}`}>
                                              Your Balance
                                          </p>
                                          <div className={`${styles.content_body} ${styles.content_body2}`}>
                                              <p className={`${styles.sub_text} m-0 mb-1`}>
                                                  Account Details
                                              </p>
                                              <div className={`${styles.bank_info}`}>
                                                  <div >
                                                      <p className={`${styles.name} m-0`}>
                                                          ADEOLA IDAYAT ADEOYE.
                                                      </p>
                                                      <p className={`${styles.account_number} m-0`}>
                                                          0036262435
                                                      </p>
                                                  </div>
                                                  <img className="" src="/assets/logo.svg" alt="" />
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                            </div>
                            <div className="col-md-4 mb-2">
                              <div className={`${styles.card2} card ply-2 `} style={{ borderRadius: '6px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                                  <div className={`${styles.wallet}`} >
                                      {/* <img className={`${styles.img} ${styles.img1}`} src="/assets/crc.png" alt="" /> */}
                                      <div className={`${styles.content}`} >
                                          <div className={`${styles.content_header} mt-1`}>
                                              <div>
                                                  ₦‎ 26,500,853
                                              </div>
                                              <div>
                                                  <img src="/assets/icons/Vector.svg" alt="" />
                                              </div>
                                          </div>
                                          <p className={`${styles.sub_text}`}>
                                              Your Balance
                                          </p>
                                          <div className={`${styles.content_body} ${styles.content_body2}`}>
                                              <p className={`${styles.sub_text} m-0 mb-1`}>
                                                  Account Details
                                              </p>
                                              <div className={`${styles.bank_info}`}>
                                                  <div >
                                                      <p className={`${styles.name} m-0`}>
                                                          ADEOLA IDAYAT ADEOYE.
                                                      </p>
                                                      <p className={`${styles.account_number} m-0`}>
                                                          0036262435
                                                      </p>
                                                  </div>
                                                  <img className="" src="/assets/logo.svg" alt="" />
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      {
                        savingsFormValues?.charge_type === 'manual' &&
                        <div className='m-2'>
                          <p>
                            Transfer <b>{" "}₦{Number(savingsFormValues?.amount).toLocaleString()} {" "}</b>
                            to the generated wallet account number below to begin your journey towards 
                            financial breakthrough. Make sure you have funds up to the stated amount in 
                            the wallet for your first savings debit.
                          </p>
                          <p>
                            <i>
                              <b>
                                Make a transfer to wallet
                              </b>
                            </i>
                          </p>
                          <div className='row'>
                            <div className="col-md-6 mb-2">
                              <div className={`${styles.card2} card p-3`} style={{ borderRadius: '6px', display: 'flex', justifyCgontent: 'center', aligjnItems: 'center' }}>

                                  <div className={`${styles.wallet}`} >
                                      {/* <img className={`${styles.img} ${styles.img1}`} src="/assets/crc.png" alt="" /> */}
                                      <div className={`${styles.content} w-100`} >
                                          <div className={`${styles.content_header}`}>
                                              <div>
                                                  ₦‎ 26,500,853
                                              </div>
                                              <div>
                                                  <img src="/assets/icons/Vector.svg" alt="" />
                                              </div>
                                          </div>
                                          <p className={`${styles.sub_text}`}>
                                              Your Balance
                                          </p>
                                          <div className={`${styles.content_body} ${styles.content_body2}`}>
                                              <p className={`${styles.sub_text} m-0 mb-1`}>
                                                  Account Details
                                              </p>
                                              <div className={`${styles.bank_info}`}>
                                                  <div >
                                                      <p className={`${styles.name} m-0`}>
                                                          ADEOLA IDAYAT ADEOYE.

                                                      </p>
                                                      <p className={`${styles.account_number} m-0`}>
                                                          0036262435
                                                      </p>

                                                  </div>
                                                  <img className="" src="/assets/images/hybrid_logo.png" alt="" />
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      {
                        savingsFormValues?.charge_type === 'wallet' &&
                        <div className='m-2'>
                          <p>
                            Direct debit of <b>{" "}₦{Number(savingsFormValues?.amount).toLocaleString()} {" "}</b> 
                            from your iSave wallet to the savings wallet. Make sure you have funds up to the stated amount in 
                            the wallet for your first savings debit.
                          </p>
                          <p>
                            <i>
                              <b>
                                iSave Wallet
                              </b>
                            </i>
                          </p>
                          <div className='row'>
                            <div className="col-md-6 mb-2">
                              <div className={`${styles.card2} card p-3`} style={{ borderRadius: '6px', display: 'flex', justifyCgontent: 'center', aligjnItems: 'center' }}>

                                  <div className={`${styles.wallet}`} >
                                      {/* <img className={`${styles.img} ${styles.img1}`} src="/assets/crc.png" alt="" /> */}
                                      <div className={`${styles.content} w-100`} >
                                          <div className={`${styles.content_header}`}>
                                              <div>
                                                  ₦‎ 26,500,853
                                              </div>
                                              <div>
                                                  <img src="/assets/icons/Vector.svg" alt="" />
                                              </div>
                                          </div>
                                          <p className={`${styles.sub_text}`}>
                                              Your Balance
                                          </p>
                                          <div className={`${styles.content_body} ${styles.content_body2}`}>
                                              <p className={`${styles.sub_text} m-0 mb-1`}>
                                                  Account Details
                                              </p>
                                              <div className={`${styles.bank_info}`}>
                                                  <div >
                                                      <p className={`${styles.name} m-0`}>
                                                          ADEOLA IDAYAT ADEOYE.

                                                      </p>
                                                      <p className={`${styles.account_number} m-0`}>
                                                          0036262435
                                                      </p>

                                                  </div>
                                                  <img className="" src="/assets/images/hybrid_logo.png" alt="" />
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                  </div>
                </div>
              </div>
              <div className="mb-4 mt-4">
                <button 
                  type="button" 
                  disabled={isSubmitPending}
                  className={`${styles.modal_btn} btn btn-block`}
                  onClick={() => handleSubmitSavingPlan()}
                >
                  {
                    !isSubmitPending && (
                      <span>
                        Proceed
                      </span>
                    )
                  }
                  {
                    isSubmitPending && 
                    <span>
                      Submitting
                      <CircularProgress className='ml-1' style={{ color: 'white' }} size="1rem" />
                    </span>
                  }
                </button>
              </div>
            </>
          }
        </GlobalModal>
      </div>

    </>
  );
}

